// What the CRM saved this week, in time, and per timesheet: the number that
// shows whether the agency is getting leaner as it grows.
import { minutesText } from "@crm/schemas/ledger";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { api } from "../lib/api.ts";

export interface LedgerView {
	days: number;
	total: number;
	lastTotal: number;
	timesheets: number;
	perTimesheet: number | null;
	rows: { key: string; label: string; instead: string; count: number; minutes: number; saved: number }[];
	wouldSave: Record<string, number | null>;
	canChange: boolean;
}
export const ledgerQuery = {
	queryKey: ["ledger", 7],
	queryFn: () => api<LedgerView>("/ledger?days=7"),
	staleTime: 60_000,
};

export function TimeSaved() {
	const q = useQuery(ledgerQuery);
	if (!q.data) return null;
	const { total, lastTotal, perTimesheet } = q.data;
	return (
		<section aria-labelledby="saved-h" className="rounded-[var(--radius-card)] bg-navy p-5 text-white">
			<h2 id="saved-h" className="text-sm font-bold tracking-[0.06em] text-mint uppercase">
				Saved for you this week
			</h2>
			<p className="mt-1 font-display text-4xl font-bold tabular-nums">{minutesText(total)}</p>
			<p className="mt-1 text-sm">
				{perTimesheet !== null ? `${perTimesheet.toFixed(1)} minutes for every timesheet. ` : ""}
				{lastTotal ? `The week before: ${minutesText(lastTotal)}.` : "Counted over the last 7 days."}
			</p>
			<Link
				to="/reports"
				hash="time-saved"
				className="mt-2 inline-block font-semibold text-mint underline underline-offset-4 hover:no-underline"
			>
				How it's worked out
			</Link>
		</section>
	);
}
